<template>
  <div class="card relative transition group hover:-translate-1 hover:shadow-2">
    <div class="overflow-hidden rounded ar-1-1">
      <img
        :src="previewUrl"
        class="transition scale-2 group-hover:scale-0"
      >
    </div>
    <div
      :class="$style.titleBackground"
      class="absolute pin-b pin-x p-4 pt-8 text-light rounded"
    >
      <h1 class="text-xl text-justify pt-8 mb-2">
        {{ album.attributes.title }}
      </h1>
      {{ album.attributes.published_at | dateHuge }}
    </div>
    <div
      :class="$style.counterBackground"
      class="absolute pin-t pin-x p-4 pb-8 text-light text-right rounded"
    >
      {{ $tc('photo', imageCount, { count: imageCount }) }}
    </div>
    <a
      :href="linkUrl"
      :target="linkTarget(linkUrl, album.meta.avoid_target_top_in_hrefs)"
      :title="linkTitle"
      class="absolute pin -m-px rounded
        border-2 border-transparent focus:border-brand-dark
        group-hover:border-brand transition"
    />
    <div
      :class="$style.secondPhoto"
      class="card absolute h-full -m-px"
    />
    <div
      :class="$style.thirdPhoto"
      class="card absolute h-full -m-px"
    />
  </div>
</template>

<script>
import { Type } from '@/src/server/helpers/constants'

export default {
  props: {
    album: {
      type: Object,
      required: true,
      validator (value) {
        return value.type === Type.ALBUM
      },
    },
  },

  computed: {
    linkTitle () {
      return this.album.attributes.title + '\n' +
        this.$options.filters.dateTimeHuge(this.album.attributes.published_at)
    },
    previewUrl () {
      const previewUrl = this.album.meta.images_url[0] || {}

      return previewUrl.medium || '/static/album-preview.png'
    },
    imageCount () {
      return this.album.meta.images_url.length
    },
    linkUrl () {
      return this.album.links.domain_url || this.album.links.public_url
    },
  },
}
</script>

<style lang="scss" module>
.grid-layout {
  grid-template-columns: repeat(auto-fill, minmax(calc(var(--font-size) * 22), 1fr));
}

.title-background {
  background: linear-gradient(
    to bottom,
    transparent,
    var(--dark-darkest) 150%
  );
}

.counter-background {
  background: linear-gradient(
    to bottom,
    var(--dark-darkest) -75%,
    transparent
  );
}

.second-photo {
  z-index: -1;
  top: -3px;
  right: -3px;
}

.third-photo {
  z-index: -2;
  top: -6px;
  right: -6px;
}
</style>



// WEBPACK FOOTER //
// src/server/components/Albums/Item.vue